import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const AgentPage = lazyWithRetry(() =>
  import('./pages/AgentPage').then((module) => ({ default: module.AgentPage })),
)

const routes: AppRoute[] = [
  {
    path: 'agent',
    element: AgentPage,
    meta: {
      title: 'sidebarNav.sergeo',
    },
  },
]

export default routes
